import { FC } from 'react';
import { Grid, Box } from '@mui/material';
import { ButtonLink } from './ButtonLink';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ICustomPageSection } from '../../models';

interface ILinkBlockSection {
  sectionName: string;
  section: ICustomPageSection;
}

export const LinkBlockSection: FC<ILinkBlockSection> = ({ section, sectionName }) => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="space-around" spacing={2}>
      {/* slightly different layout for the feedback section */}
      {sectionName === 'Feedback' && (
        <>
          {section?.sections?.map((sec, index) => {
            // half width for the first two buttons, then thirds for the rest
            const isHalf = index === 0 || index === 1;
            return (
              <Grid item xs={12} sm={isHalf ? 6 : 4} key={`${index}`}>
                <ButtonLink section={sec} />
              </Grid>
            );
          })}
        </>
      )}
      {sectionName !== 'Feedback' &&
        section?.sections?.map((sec, index) => {
          const isFirstItem = index === 0;
          return (
            <Grid item xs={12} sm={isFirstItem ? 12 : 6} key={`${index}`}>
              {isFirstItem ? (
                <Box
                  margin={{
                    xs: 0,
                    sm: '0 auto'
                  }}
                  width={{
                    xs: '100%',
                    sm: '80%'
                  }}
                >
                  <ButtonLink section={sec} buttonLinkTitleClassName={classes.title} buttonLinkClassName={classes.linkButton} />
                </Box>
              ) : (
                <ButtonLink section={sec} />
              )}
            </Grid>
          );
        })}
    </Grid>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  title: {
    fontSize: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2rem'
    }
  },
  linkButton: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '50%'
    }
  }
}));
